<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :footer-method="() => footerData"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:platformName="{ row }">
        <div class="m-0">
          <TableLabel :label="''" :value="row.platformName" />
          <TableLabel :label="''" :value="row.custName" />
        </div>
      </template>
      <template v-slot:whName="{ row }">
        <div class="m-0">
          <TableLabel :label="''" :value="row.whName" />
          <TableLabel :label="''" :value="row.whAddress" />
        </div>
      </template>
      <template v-slot:createByName="{ row }">
        <div class="m-0">
          <TableLabel :label="''" :value="row.createByName" />
          <TableLabel :label="''" :value="row.createTime" />
        </div>
      </template>
      <template v-slot:expandContent="{ row }">
        <div class="p-2">
          <BatchSkuTable :evgPurchaseBatchCode="row.evgPurchaseBatchCode" />
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import BatchSkuTable from '../batch-sku-table'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight],
  components: { BatchSkuTable, TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    totalData: { type: Object, default: () => {} },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = this.totalData[t.field]
          return val ? format(val) : '0'
        })
      result[1] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  watch: {
    totalData: {
      handler() {
        this.$refs.table.updateFooter()
      },
      deep: true,
    },
  },
}
</script>
